<div *ngIf="doctor && doctor?.doctorHoliday==false"
     [dir]="language == 'ar'?'rtl':'ltr'"
     class="appointment-container">

  <app-stepper-progress-bar
      *ngIf="doctor"
      [steps]="steps"
      [activeIndex]="activeIndex"
      [dir]="language"
      class="w-100">
  </app-stepper-progress-bar>

  <div class="appointment-content">    <div class="row g-3 align-items-stretch">

      <!-- Doctor card -->
      <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngIf="language=='fr'">

        <div class="card doctor-card">

          <div class="card-header bg-transparent">

            <div class="doctor-info-header">

              <div class="user-avatar">
                <img [src]="doctor | avatarSrc" class="img-fluid" alt="">
              </div>

              <div class="doctor-name-group">
                <h5 class="name">{{doctor.getFullName()}}</h5>
                <span class="text-secondary">
                  {{doctor.speciality.label}}
                </span>
              </div>

            </div>

          </div>

          <div class="body p-2">

            <div class="text-secondary">
              <strong>Adresse :</strong> {{doctor.address}}
            </div>

            <div class="mt-2 text-secondary">
              <strong>Tél :</strong> {{doctor.fixPhone}}
              <strong>Mobile :</strong> {{doctor.mobilePhone1}}
            </div>

          </div>

        </div>

      </div>

      <!-- Arabic card -->

      <div class="col-12 col-md-6 col-lg-4 col-xl-3" *ngIf="language=='ar'">

        <div class="card doctor-card">

          <div class="card-header bg-transparent">

            <div class="doctor-info-header">

              <div class="user-avatar">
                <img [src]="doctor | avatarSrc" class="img-fluid" alt="">
              </div>

              <div class="doctor-name-group text-end">
                <h5 class="name-ar">
                  {{doctor.arabicProfessionalCivility}}
                  {{doctor.arabicFirstName}}
                  {{doctor.arabicLastName}}
                </h5>

                <span class="text-secondary">
                  {{doctor.speciality?.arabicName}}
                </span>

              </div>

            </div>

          </div>

          <div class="body p-2 text-end">

            <div class="text-secondary">
              <strong>العنوان :</strong> {{doctor.arabicAddress}}
            </div>

            <div class="mt-2 text-secondary">
              <strong>الهاتف :</strong> {{doctor.fixPhone}}
              <strong>الجوال :</strong> {{doctor.mobilePhone1}}
            </div>

          </div>

        </div>

      </div>

      <!-- Calendar -->

      <div class="col-12 col-lg-8 col-xl">

        <div class="card h-100 calendar-card">

          <app-appointment-booking-calender
              *ngIf="activeIndex == 0"
              [doctor]="doctor"
              [patientAppointment]="patientAppointment"
              [dir]="language">
          </app-appointment-booking-calender>

          <app-appointment-booking-verification
              *ngIf="activeIndex == 1"
              [doctor]="doctor"
              [dir]="language"
              [patientAppointment]="patientAppointment">
          </app-appointment-booking-verification>

          <app-appointment-patient-verification
              *ngIf="activeIndex == 2"
              [dir]="language"
              [patientAppointment]="patientAppointment">
          </app-appointment-patient-verification>

          <app-appointment-booking-payment
              *ngIf="activeIndex == 3"
              [dir]="language"
              [language]="language"
              [patientAppointment]="patientAppointment"
              (paymentComplete)="activeIndex = 4">
          </app-appointment-booking-payment>

          <app-appointment-success-booking
              *ngIf="activeIndex == 4"
              [doctor]="doctor"
              [dir]="language"
              [patientAppointment]="patientAppointment">
          </app-appointment-success-booking>

          <!-- buttons -->

          <div class="booking-buttons">

            <a *ngIf="activeIndex == 0"
               href="javascript:void(0)"
               class="btn button-pra"
               [ngClass]="{'disabled':!appointmentBookingCalenderComponent?.valid}"
               (click)="onAppointmentVerificationRequested()">
               {{language=='ar'?'تأكيد':'Enregistrer'}}
            </a>

            <a *ngIf="activeIndex == 1"
               href="javascript:void(0)"
               class="btn button-pra"
               [ngClass]="{'disabled':!appointmentBookingVerificationComponent?.valid}"
               (click)="onAppointmentConfirmationRequested()">
               {{language=='ar'?'تأكيد':'Confirmer'}}
            </a>

            <a *ngIf="activeIndex == 2"
               href="javascript:void(0)"
               class="btn button-pra"
               [ngClass]="{'disabled':!appointmentPatientVerificationComponent?.valid}"
               (click)="onAppointmentConfirmed()">
               {{language=='ar'?'تأكيد':'Confirmer'}}
            </a>

          </div>

        </div>

      </div>

    </div>
  </div>
</div>